'use es6';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import UIAlert from 'UIComponents/alert/UIAlert';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getContentTypeLimit } from 'ContentEditorUI/redux/selectors/limitSelectors';
import { getPageLimitLangKey } from '../redux/selectors/pageLimitSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const mapStateToProps = state => ({
  pageLimit: getContentTypeLimit(state),
  langKey: getPageLimitLangKey(state)
});
const LimitExceededError = ({
  pageLimit,
  langKey
}) => /*#__PURE__*/_jsx(UIAlert, {
  titleText: /*#__PURE__*/_jsx(FormattedMessage, {
    message: `limitExceededError.${langKey}.title`,
    options: {
      count: pageLimit.pageLimit,
      quantityUsed: pageLimit.quantityUsed
    }
  }),
  type: "danger",
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: `limitExceededError.${langKey}.message`,
    options: {
      count: pageLimit.quantityUsed - pageLimit.pageLimit
    }
  })
});
LimitExceededError.propTypes = {
  pageLimit: PropTypes.object.isRequired,
  langKey: PropTypes.string.isRequired
};
export default connect(mapStateToProps)(LimitExceededError);